import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2';
import QuillEditorComponent from '../components/QuillEditorComponent'
import VisComponent from '../components/VisComponent'
import OptionsMenu from '../components/OptionsMenu'
import { FiArrowRightCircle } from "@react-icons/all-files/fi/FiArrowRightCircle"
import '../App.css'
import { useSelector } from 'react-redux'

export default function BuildingArea() {
    const handleRightClickPreventDefault = (e) => {
        e.preventDefault(); // prevent the default behaviour when right clicked
    }
    const timeLines = useSelector((state) => state.project.timeLines)
    // let timeLinesLength
    const [timeLineID, setTimeLine] = useState(0)

    return (
        <div>
            <OptionsMenu timeLineID={timeLineID} setTimeLine={setTimeLine}/>
            <div className="containerData" >
                <div className="half left"
                    style={{ maxWidth: '35%', padding: '2vh' }}>
                    <div style={{ display: 'inline-flex' }}>
                        <p style={{ fontSize: '24px', color: '#FFFFFF' }}>Línea de Suceso: <span style={{ color: '#878787' }}>{timeLines[timeLineID].timeLineName}</span><span style={{ color: '#878787', fontSize: '50%' }}> - {timeLines[timeLineID].date}</span></p>

                        <span id='activador' style={{ color: '#FFFFFF', fontSize: '22px', marginLeft: '10px', paddingInlineEnd: '10px', cursor: 'pointer' }} onClick={() => {
                            Swal.fire({
                                title: 'Seleccionar Momento',
                                input: 'select',
                                // inputLabel: 'Elige la línea de tiempo',
                                inputOptions: timeLines.map((obj) => {
                                    return (obj.timeLineID + " - " + obj.timeLineName)
                                }),
                                inputPlaceholder: 'Elige la línea de tiempo',
                                focusConfirm: false,
                                showCancelButton: true,
                                inputValidator: (value) => {
                                    if (!value) {
                                        return 'Hey... No seleccionó ninguna Línea de tiempo'
                                    } else {
                                        setTimeLine(value[0])
                                        // Ejecutar Lógica para re acomodar el Momento(TL) y
                                        // el lugar (Campo Relacional)
                                    }
                                }
                            })
                        }}> <FiArrowRightCircle /> </span>
                    </div>
                    <span style={{ color: '#878787' }}>
                        {timeLines[timeLineID].tlPlace}
                    </span>
                    <div id="editor"
                        onContextMenu={handleRightClickPreventDefault}
                        style={{ color: '#FFFFFF', border: '1px solid #7a7a7a', borderRadius: '20px', height: '90%', padding: '10px' }}
                    >
                        <QuillEditorComponent timeLineID={timeLineID} />
                    </div>
                </div>
                <div className="half right">
                    <VisComponent timeLineID={timeLineID} />
                </div>
            </div>
        </div >
    )
}